import { useEffect, useState } from "react";
import SideMenu from "../Components/SideMenu";
import '../products.css';
import axios from "axios";

export default function Products() {
    function toggleMenu(e) {
        e.preventDefault();
        const menu = document.querySelector('.side-menu');
        menu.classList.toggle('hidden');
    }
    const [items, setItems] = useState([]);
    function getProducts() {
        axios.get(`${process.env.REACT_APP_API_URL}/items`, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem("token")}`
            }
        })
            .then(response => {
                console.log("Products data:", response.data);
                setItems(response.data);
                // Handle the fetched products data here
            })
            .catch(error => {
                alert('Please try again later')
                console.error("Error fetching products data:", error);
            });
    }

    function handleSearch(e) {
        e.preventDefault();
        alert("Search functionality not implemented yet.");

    }

    useEffect(() => {
        document.title = "Products - IMS";
        getProducts();
    }, [])
    return (
        <div className="App">
            <header className="App-header">
                <section className="top-left-corner">
                    <img src="https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg" className="logo" alt="logo" />
                    <p>
                        MVP
                    </p>
                </section>
                <button className="menu-btn" onClick={toggleMenu}>&#9776;</button>
                {/* <button onClick={clearToken} className="clear-token-btn">Clear Token</button> */}
                <SideMenu />

            </header>
            <main style={{ color: 'white' }}>
                <h2>Products</h2>
                <form className="productsearch-form">
                    <input type="text" placeholder="Search products..." />
                    <button id="search-btn" onClick={handleSearch} type="submit">Search</button>
                </form>
                <ul id="product-list">
                    <li>
                        <p>Name</p>

                        <p>Price</p>
                        <p>Status</p>
                    </li>
                    {items.map((item, index) => (
                        <li key={index} onClick={() => window.location.href = `/product/${item.qr_id}`}>
                            <p>{item.name}</p>

                            <p>{item.price} ETB</p>
                            <p style={{ color: item.sold ? 'red' : 'lightgreen', fontWeight: 'bold' }}>{item.sold ? 'SOLD' : 'AVAILABLE'}</p>
                        </li>
                    ))}
                </ul>
            </main>
        </div>
    );
}
